import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { filter, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HardshipInitialCardComponent } from './hardship-cards/hardship-initial-card/hardship-initial-card.component';
import { HardshipActionsCardComponent } from './hardship-cards/hardship-actions-card/hardship-actions-card.component';
import { HardshipRequiredDocsService } from './hardship-required-docs.service';

@Injectable({
  providedIn: 'root'
})
export class HardshipCardsService {


  private _hardshipRequiredDocsService = inject(HardshipRequiredDocsService);
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private readonly _destroyRef = inject(DestroyRef);

  private _currentState = signal<ServiceState | null | undefined>(undefined);
  public currentState = this._currentState.asReadonly();


  constructor() {
    this._serviceInventory.getService('hardship_application')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          this._currentState.set(service.state);
          
          switch (service.state) {
            case ServiceState.INITIAL:
              this.registerHardshipInitialCard();
              break;
            case ServiceState.READY:
            case ServiceState.UPLOAD:
            case ServiceState.REVIEW:
              this.registerHardShipActionCards(service.route || '', service.state);
              break;
            case ServiceState.INACTIVE:
              this._homeFeedService.removeHomeFeedCard('hardship', HomeFeedSection.ACTIONS);
              this._homeFeedService.removeHomeFeedCard('hardship', HomeFeedSection.PROGRAMS);
              break;  
          }
        }),
        takeUntilDestroyed(this._destroyRef)
      ).subscribe();
  }

  private registerHardshipInitialCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'hardship',
      component: 'HardshipInitialCardComponent',
      componentRef: HardshipInitialCardComponent,
      data: null,
      order: 0,
      section: HomeFeedSection.PROGRAMS
    });
  }

  private registerHardShipActionCards(route: string, state: string) {
    this._homeFeedService.removeHomeFeedCard('hardship', HomeFeedSection.ACTIONS);
    this._homeFeedService.removeHomeFeedCard('hardship', HomeFeedSection.PROGRAMS);

    if (state === ServiceState.READY) {
      this._hardshipRequiredDocsService.setActiveView('hardship_confirm_request');
    } else if (state === ServiceState.REVIEW) {
      this._hardshipRequiredDocsService.setActiveView('hardship_request_details');
    }

    setTimeout(() => {
      this._homeFeedService.registerHomeFeedCard({
        key: 'hardship',
        component: 'HardshipActionCardComponent',
        componentRef: HardshipActionsCardComponent,
        data: {route, state},
        section: HomeFeedSection.ACTIONS,
        order: 0,
      })
    }, 250);
  }

}
